import { addNotification, removeNotification } from './reducer';


export const triggerNotification = (message, type = 'info', duration = 2000) => (dispatch) => {
  const action = addNotification(message, type); // This is the full action with payload
  dispatch(action); // ✅ Dispatch full action

  const id = action.payload.id; // ✅ Access ID properly

  setTimeout(() => {
    dispatch(removeNotification(id)); // ✅ Correct ID
  }, duration);
};


export const triggerSaveSuccessNotif = ({
  successMsg = "Uspešno shranjeno!",
  type = "success",
  duration = 3000,
} = {}) => (dispatch) => {
  if(successMsg == null){
    return
  }
  const action = addNotification(successMsg, type); // This is the full action with payload
  dispatch(action);

  const id = action.payload.id;

  setTimeout(() => {
    dispatch(removeNotification(id));
  }, duration);
};

export const triggerErrorNotif = (message = "Error", type = 'error', duration = 3000) => (dispatch) => {
  const action = addNotification(message, type); // This is the full action with payload
  dispatch(action);

  const id = action.payload.id;

  setTimeout(() => {
    dispatch(removeNotification(id));
  }, duration);
};

export const triggerWarnNotif = (message = "Error", type = 'warning', duration = 3000) => (dispatch) => {
  const action = addNotification(message, type); // This is the full action with payload
  dispatch(action);

  const id = action.payload.id;

  setTimeout(() => {
    dispatch(removeNotification(id));
  }, duration);
};
